import React from 'react'
import { useTranslation } from 'react-i18next'
import TwoFAModal from 'components/modals/TwoFAModal/TwoFAModal'
import { useTwoFAContext } from 'hooks/useTwoFAContext'

interface ApiKeyEnable2FAModalProps {
  onComplete: () => void
}

export const ApiKeyEnable2FAModal = ({ onComplete }: ApiKeyEnable2FAModalProps) => {
  const { t } = useTranslation()
  const { showTwoFAModal } = useTwoFAContext()

  if (showTwoFAModal) {
    return (
      <TwoFAModal
        notice={{
          navTitle: t('enable2FAAuthentication'),
          heading: '',
          description: t('2FAEnableNotice'),
        }}
        onComplete={onComplete}
      />
    )
  }

  return null
}
